export const emitPing = (url, window) => {
    const pingImage = window.document.createElement('img');
    pingImage.src = url;
    pingImage.height = '0';
    pingImage.width = '0';
    pingImage.style.border = '0';

    window.document.body.appendChild(pingImage);
};
